export default __webpack_public_path__ + "static/media/permissions.c7ce547a.svg";